import { queryKeys } from "@/services/react-query.service/query-keys";
import { QueryClient } from "@tanstack/react-query";

interface MunicipalPropertyRefreshScope {
  workspaceId: string;
  propertyIdList: readonly string[];
}

export async function refreshMunicipalPropertyCatalog({
  queryClient,
  scope,
  throwOnError = false,
}: {
  queryClient: QueryClient;
  scope: MunicipalPropertyRefreshScope;
  throwOnError?: boolean;
}): Promise<void> {
  const { workspaceId, propertyIdList }: MunicipalPropertyRefreshScope = scope;
  await Promise.all([
    queryClient.resetQueries({ queryKey: queryKeys.municipalProperties.workspaceLists(workspaceId) }, { throwOnError }),
    ...propertyIdList.map(
      (propertyId: string): Promise<void> =>
        queryClient.resetQueries(
          {
            queryKey: queryKeys.municipalProperties.histories(propertyId),
          },
          { throwOnError },
        ),
    ),
    queryClient.invalidateQueries(
      {
        queryKey: queryKeys.trash.workspaceLists(workspaceId),
      },
      { throwOnError },
    ),
  ]);
}
